import audienceApi from 'api/audienceApi'
import {
  AudienceListRequest,
  AudienceListResponse,
  ProvinceListResponse,
  CountryListResponse,
  DistrictListResponse,
  SubDistrictListResponse,
  CropsListResponse,
  AudienceSaveRequest,
  VillageListResponse,
  EstimatedAudience
} from './types'
import { getPaginationQueryParams } from './utils'

const AudienceApiSlice = audienceApi.injectEndpoints({
  endpoints: (build) => ({
    createAudience: build.mutation<AudienceListResponse, AudienceSaveRequest>({
      query: (audienceData) => {
        return {
          url: '/audiences/extended',
          method: 'POST',
          data: audienceData
        }
      },
      invalidatesTags: ['audience']
    }),
    getCountry: build.query<CountryListResponse, void>({
      query: () => ({
        url: '/countries',
        method: 'GET'
      }),
      providesTags: ['country']
    }),
    getProvinces: build.query<ProvinceListResponse, number>({
      query: (id) => ({
        url: '/states',
        method: 'GET',
        params: { 'countryId.equals': id }
      }),
      providesTags: ['province']
    }),
    getDistricts: build.query<DistrictListResponse, number>({
      query: (id) => ({
        url: '/districts',
        method: 'GET',
        params: { 'stateId.equals': id }
      }),
      providesTags: ['district']
    }),
    getSubDistricts: build.query<SubDistrictListResponse, number>({
      query: (id) => ({
        url: '/talukas',
        method: 'GET',
        params: { 'districtId.equals': id }
      }),
      providesTags: ['taluka']
    }),
    getVillages: build.query<VillageListResponse, number>({
      query: (id) => ({
        url: '/villages',
        method: 'GET',
        params: { 'subDistrictId.equals': id }
      }),
      providesTags: ['village']
    }),
    getCrops: build.query<CropsListResponse, void>({
      query: () => ({
        url: '/crops',
        method: 'GET'
      }),
      providesTags: ['crop']
    }),
    getAudienceList: build.query<AudienceListResponse, AudienceListRequest>({
      query: (request) => {
        const params = getPaginationQueryParams(request)
        return {
          url: '/audiences/extended',
          method: 'GET',
          params
        }
      },
      providesTags: ['audience']
    }),
    getAudienceCount: build.query<number, EstimatedAudience>({
      query: (request) => ({
        url: '/clients/extended/count',
        method: 'GET',
        params: request
      }),
      providesTags: ['audience']
    })
  })
})

export const {
  useCreateAudienceMutation,
  useGetProvincesQuery,
  useGetCountryQuery,
  useGetVillagesQuery,
  useGetDistrictsQuery,
  useGetSubDistrictsQuery,
  useGetCropsQuery,
  useGetAudienceListQuery,
  useGetAudienceCountQuery
} = AudienceApiSlice
export default audienceApi
